import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';

const useLecturerHistory = (searchParams: LecturerHistoryListReqDto) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [historyList, setHistoryList] = useState<any[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: INIT_PAGESIZE, totalCount: 0 });

  /* ======================================================
   * hooks
   * ====================================================== */
  const { isLoading, refetch } = useQuery(
    [endpoints.lecturer.history, searchParams],
    () =>
      fetcher.lecturer.postLecturerHistoryList({
        pageNo: Number(searchParams.pageNo) || 1,
        pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
        id: searchParams.id,
        searchValue: searchParams.searchValue ? String(searchParams.searchValue) : '',  
        searchDateStart: searchParams.searchDateStart ? String(searchParams.searchDateStart) : '',   
        searchDateEnd: searchParams.searchDateEnd ? String(searchParams.searchDateEnd) : '',  
        lecture_subject: searchParams.lecture_subject ? String(searchParams.lecture_subject) : '',  
        lecture_type: searchParams.lecture_type ? String(searchParams.lecture_type) : '',  
      }),
    {
      onSuccess: (res: CommonSearchListResDto) => {
        switch (res.code) {
          case 200:
            setHistoryList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || INIT_PAGESIZE,
              totalCount: res.result?.totalCount || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { historyList, searchResult, refetch };
};

export default useLecturerHistory;
